var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "#fff",
    stroke: "#AAA",
    opacity: 0.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5648_22635)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5648_22635)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FBBB00",
    d: "m14.603 22.792-.675 2.519-2.466.052a9.65 9.65 0 0 1-1.155-4.593c0-1.607.39-3.123 1.083-4.457l2.196.402.962 2.183a5.8 5.8 0 0 0-.31 1.872c0 .711.128 1.393.365 2.022"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#518EF8",
    d: "M29.523 18.959a9.71 9.71 0 0 1-.043 3.834 9.7 9.7 0 0 1-3.412 5.535l-2.766-.142-.392-2.443a5.78 5.78 0 0 0 2.486-2.95h-5.183V18.96h9.31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#28B446",
    d: "M26.065 28.328za9.65 9.65 0 0 1-6.068 2.134 9.69 9.69 0 0 1-8.537-5.099l3.14-2.571a5.763 5.763 0 0 0 8.308 2.951z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F14336",
    d: "m26.186 13.309-3.14 2.57a5.765 5.765 0 0 0-8.497 3.018l-3.158-2.585a9.69 9.69 0 0 1 8.608-5.235c2.352 0 4.508.838 6.187 2.232"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5648_22635"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.23 10h21.538v21.538H9.23z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5648_22635"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.307 11.077h19.385v19.385H10.307z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_5648_22635"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-258.924-253.847h551.385v551.385h-551.385z"
  })))));
};
export default SvgGoogle;